/**
 * @fileoverview Define the Task IDs, used by the individual steps. These forward declarations are
 * necessary to prevent circular dependencies, such as how the Summary task can return to the
 * Select Entities task, but the Select Entities task must also be able to reset the Summary task.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

export const TaskIds = {
  SELECT_ENTITIES: 'selectEntities',
  SELECT_FEATURES: 'selectFeatures',
  FACEBOOK_LINKED_ACCOUNT: 'facebookLinkedAccount',
  FACEBOOK_SYNCED_FIELDS: 'facebookSyncedFields',
  GBP_LINKED_ACCOUNT: 'gbpLinkedAccount',
  GBP_SYNCED_FIELDS: 'gbpSyncedFields',
  APPLE_LINKED_ACCOUNT: 'appleLinkedAccount',
  YELP_LINKED_ACCOUNT: 'yelpLinkedAccount',
  YELP_SYNCED_FIELDS: 'yelpSyncedFields',
  SPECIFY_LISTING_CONFIGURATION: 'specifyListingConfiguration',
  SUMMARY: 'summary',
};
